<template>
  <WhitePage :loading="loading">
    <title-bar>{{ name }}</title-bar>
    <!-- <result-nav></result-nav> -->
    <list-nav />
    <div v-if="bg">
      <b-img :src="bg" width="1000" height="300" fluid></b-img>
    </div>
    <p>
      <b-table-simple small>
        <b-tbody>
          <b-tr>
            <b-td>世界名</b-td>
            <b-td>{{ name }}</b-td>
          </b-tr>
          <b-tr>
            <b-td>Lv</b-td>
            <b-td>{{ lv }}</b-td>
          </b-tr>
          <b-tr>
            <b-td>作成者</b-td>
            <b-td>{{ characterName }}({{ eno }})</b-td>
          </b-tr>
          <b-tr>
            <b-td>次回更新日</b-td>
            <b-td>{{ nextUpdateDate }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </p>
    <p v-html="note" class="note" />
  </WhitePage>
</template>

<script>
import phina from 'phina.js'
import store from '@/store'
import WhitePage from '@/components/WhitePage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
// import ResultNav from '@/components/ResultNav'
// import SelectList from '@/components/SelectList'
import ListNav from '@/components/ListNav'
import moment from 'moment'
export default {
  components: {
    WhitePage,
    TitleBar,
    // ResultNav,
    // SelectList,
    ListNav
  },
  computed: {
    nextUpdateDate () {
      return moment(new Date(this.nextUpdate*1000)).format('YYYY/MM/DD')
    }
  },
  data () {
    return {
      name: '',
      bg: '',
      lv: 0,
      note: '',
      eno: 0,
      characterName: '',
      nextUpdate: Date.now(),
      loading: false
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
      this.name = response.name
      this.bg = response.bg
      this.lv = response.lv
      this.note = response.note
      this.eno = response.eno
      this.nextUpdate = response.nextUpdate
      this.characterName = response.characterName
    }
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getWorld', route.params.id)
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    // this.checkLogin()
  },
  mounted () {
    phina.global.app.currentScene.exit('MainScene')
  }
}
</script>

<style lang="scss" scoped>
.eno {
  position: relative;
  top: 20px;
  font-size: medium;
}
#manage ::v-deep .manage-table {
  overflow-x: scroll;

  table {
    width: 1000px;
  }
}
// Status.note
.note {
  width: 100%;
  min-height: 300px;
  background-color: rgba(255,255,255,0.2);

  background-blend-mode: lighten;

  border-image: url('../assets/ui/frame3.png') 5;
  border-style:solid;
  border-width: 5px;

  ::v-deep .ql-size-large {
    font-size: 1.5em;
  }
  ::v-deep .ql-size-small {
    font-size: .75em;
  }
  ::v-deep .ql-size-huge {
    font-size: 2.5em;
  }
}
</style>
